module.exports = __webpack_public_path__ + "img/img52.23594ddf.png";